(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sportinfo/match-info-redux/assets/normalize-event.js') >= 0) return;  svs.modules.push('/components/sportinfo/match-info-redux/assets/normalize-event.js');
"use strict";

const _excluded = ["country"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }

let normalizeProviders;
let resolveProductId;
if (svs.isServer) {
  const trinidad = require('@svenskaspelab/trinidad-core').core;
  resolveProductId = trinidad.components.require('utils', 'products').resolveProductId;
  normalizeProviders = require('./normalize-providers.es6');
} else {
  resolveProductId = svs.utils.products.resolveProductId;
  normalizeProviders = svs.components.sport.matchInfoRedux.normalizeProviders;
}
const normalizeEvent = (sportEvent, distributions) => {
  const participants = sportEvent.participants,
    realLeague = sportEvent.league,
    venue = sportEvent.venue,
    matchStart = sportEvent.startTime,
    status = sportEvent.status,
    statusTime = sportEvent.statusTime,
    realSport = sportEvent.sport,
    sportEventProviderIds = sportEvent.providerIds;
  const parsedParticipants = participants.map(_ref => {
    let id = _ref.sportEventParticipantId,
      shortName = _ref.shortName,
      mediumName = _ref.mediumName,
      name = _ref.name;
    return {
      id,
      mediumName,
      name,
      shortName
    };
  });
  const _parsedParticipants = _slicedToArray(parsedParticipants, 2),
    homeTeam = _parsedParticipants[0],
    awayTeam = _parsedParticipants[1];
  const _ref2 = realLeague || {},
    realCountry = _ref2.country,
    league = _objectWithoutProperties(_ref2, _excluded);
  const sport = {
    name: realSport.name,
    type: realSport.sportType
  };
  const country = _objectSpread(_objectSpread({}, realCountry), {}, {
    id: realCountry.countryId
  });
  const parsedLeague = {
    id: league.leagueId,
    name: league.name
  };
  const match = {
    arena: (venue === null || venue === void 0 ? void 0 : venue.name) || null,
    distributions,
    matchStart,
    sportEventStatus: status,
    statusTime
  };
  const parsedDistributions = (distributions !== null && distributions !== void 0 ? distributions : []).reduce((acc, distribution) => _objectSpread(_objectSpread({}, acc), {}, {
    [resolveProductId(distribution.productName)]: distribution
  }), {});
  const providerIds = normalizeProviders(sportEventProviderIds);
  return {
    homeTeam,
    awayTeam,
    league: parsedLeague,
    distributions: parsedDistributions,
    match,
    country,
    sport,
    providerIds
  };
};
if (svs.isServer) {
  module.exports = normalizeEvent;
} else {
  setGlobal('svs.components.sportinfo.matchInfoRedux.normalizeEvent', normalizeEvent);
}

 })(window);